import * as Immutable from 'immutable';
import moment from 'moment';
// tslint:disable-next-line:no-import-side-effect
import 'moment-timezone';
import 'moment/locale/vi';
import 'moment/locale/ko';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';

import { reverifyEmailUser } from '../../actions/AccountActions/AccountActions';
import { fetchAlphasOptions } from '../../actions/AlphasActions';
import {
  checkIfAuth,
  checkIfSessionExpired,
  getConfiguration,
  getUserSettings,
  sessionExpire,
  userLogoutIfLoggedOut,
} from '../../actions/AuthenticationActions';
import { getCurrentCompetition, getUserCompetitions, setLogoutCompetition } from '../../actions/CompetitionsActions';
import { fetchSimulationOptions } from '../../actions/EditorActions/EditorActions';
import { addFlashMessages, removeAllFlashMessages, removeFlashContexts } from '../../actions/FlashMessagesActions';
import { getSummary } from '../../actions/MessagesActions';
import { fetchAllTeams } from '../../actions/Team/TeamActions';
import { GoogleAnalytics } from '../../components';
import FlashMessages from '../../components/FlashMessages/FlashMessages';
import { Footer } from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { Loader } from '../../components/Loader';
import { OnboardingPopupContainer } from '../../components/OnboardingPopup/OnboardinPopup';
import { GoldTierModal } from '../GoldTierModal/GoldTierModal';
import { StreakFreezeUnlockModal } from '../StreakFreezeUnlockModal/StreakFreezeUnlockModal';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import RecertificateRoute from '../../components/RecertificateRoute/RecertificateRoute';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import { APP_EMAIL, APP_VERSION } from '../../config';
import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';
import { accountUnverifiedEmailSelector } from '../../reducers/AccountReducer/AccountSelector';
import {
  getIsLoggedInSelector,
  getRedirectUrl,
  getUserFetchingAuthSelector,
  getUserHasLoggedInBeforeSelector,
  getUserIdSelector,
  getUserIsFetchingLogoutSelector,
  getUserIsFetchingSelector,
  getUserNeedsRecertificationSelector,
  getUserPermissionsSelector,
  getUserTimeToLogoutSelector,
  hasConsultantPermission,
} from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { flashMessagesTopGenericMessageSelector } from '../../reducers/FlashMessageReducer/FlashMessageSelector';
import {
  competitionFetchAgreeGuidelinesSelector,
  competitionFetchUserCompetitionsSelector,
} from '../../reducers/CompetitionsReducer/CompetitionsSelector';
import {
  ALPHA_DETAIL_PATH,
  ALPHAS_SUPER_SELECTION,
  ALPHATHON_LANDING_PATH,
  COMMUNITY_TOPICS_URL,
  COMPETITION_DETAILS_PATH,
  CONSULTANT_PROGRAM_LANDING_PATH,
  HELP_CENTER_URL,
  IQC_LANDING_ROUTE,
  LEARN_OLD_DATA_AND_OPERATORS_PAGE_PATH,
  LEARN_OPERATORS_PAGE_PATH,
  PROFILE_DEACTIVATE_PAGE_PATH,
  REACT_SNAP_USER_AGENT,
  SIGN_UP,
  IQC_COMPETITION_ID,
} from '../../shared/constants';
import { setUTMCookie } from '../../shared/helpers';
import { clearStoredReduxState } from '../../shared/helpers/local-storage';
import { logErrorService } from '../../shared/services';
import { useCompetition } from '../../shared/api/apiHooks';
import { DispatchConnect } from '../../types/';
import { ErrorBoundary } from '../ErrorBoundary';
import { createPortal } from 'react-dom';
import { Helmet } from 'react-helmet';
import { localStorageService } from '../../shared/services/localStorageService';
import analytics from '../../shared/services/analytics/analytics';
import DataRoutes from '../DataExplorer/DataRoutes';
import { ConsultantLanding } from '../ConsultantLanding/ConsultantLanding';
import { ScrollTracker } from '../../shared/services/analytics/ScrollTracker';
import { AppInitAltcha } from '../Altcha/AltchaWidget';
import { GoogleAds, GoogleTagManager } from '../../components/GoogleAnalytics/GoogleAnalytics';
import { MAIN_DATA_PATH } from '../DataExplorer/dataExplorerRouterPaths';

import IQCLanding from '../IQCLanding/IQCLanding';

const CompetitionSubmissions = React.lazy(() => import('../CompetitionWithSubmissions/CompetitionWithSubmissionsPage'));

const Dashboard = React.lazy(() => import('../Dashboard/Dashboard'));
const Simulate = React.lazy(() => import('../Simulate/Simulate'));
const Alphas = React.lazy(() => import('../Alphas/Alphas'));
const Alpha = React.lazy(() => import('../Alpha/Alpha'));
const AlphathonLanding = React.lazy(() => import('../AlphathonLanding/AlphathonLanding'));
//const IQCLanding = React.lazy(() => import('../IQCLanding/IQCLanding'));
const Profile = React.lazy(() => import('../Profile/Profile'));
const Events = React.lazy(() => import('../Events/Events'));
const Learn = React.lazy(() => import('../Learn/Learn'));
const AccountCreate = React.lazy(() => import('../Account/AccountCreate'));
const Authentication = React.lazy(() => import('../Authentication/Authentication'));
const Messages = React.lazy(() => import('../Messages/Messages'));
const ReferralPage = React.lazy(() => import('../ReferralProgram/ReferralProgram'));
const GeniusPage = React.lazy(() => import('../GeniusProgram/GeniusProgram'));
const AllCompetitions = React.lazy(() => import('../Competitions/AllCompetitions'));
const Competitions = React.lazy(() => import('../Competitions/Competitions'));
const AccountVerified = React.lazy(() => import('../Account/AccountVerified'));
const Reverify = React.lazy(() => import('../Reverify/Reverify'));
const ForgotPassword = React.lazy(() => import('../ForgotPassword/ForgotPassword'));
const ResetPassword = React.lazy(() => import('../ResetPassword/ResetPassword'));
const SetPassword = React.lazy(() => import('../SetPassword/SetPassword'));
const PublicAgreement = React.lazy(() => import('../../components/Agreements/PublicAgreement'));
const AccountRecertify = React.lazy(() => import('../Account/AccountRecertify'));
const Team = React.lazy(() => import('../Team/Team'));
const NotFound = React.lazy(() => import('../../components/NotFound/NotFound'));

moment.locale('en');

interface AppStateProps {
  userId: string;
  isConsultant: boolean;
  isLoggedIn: boolean;
  agreedWithGuidelines: boolean;
  fetchingAuth: boolean;
  userPermissions: Immutable.List<string>;
  userTimeout: number;
  hasLoggedInBefore: boolean;
  fetchingAuthCheck: boolean;
  recert: boolean;
  redirectUrl?: string;
  isFetchingLogout: boolean;
  fetchUserCompetitions: boolean;
  unverifiedEmail: string;
  unverifiedEmailFlashMessages: Immutable.List<any>;
}

interface AppProps {
  id: string;
}

interface AppState {
  openMobileMenu: boolean;
}

interface AppStateDispatchers {
  dispatchSetLogoutCompetition: (competition: string) => void;
  dispatchGetCompetition: (competitionId: string) => Promise<object>;
  dispatchGetOptions: () => void;
  dispatchErrorMessage: (message: string) => void;
  dispatchAddFlashMessage: (message: string) => void;
  dispatchAddFlashMessages: (messages: Object[], option: any) => void;
  dispatchFetchSummary: () => void;
  authenticationLogin(): Promise<object>;
  dispatchGetConfiguration(): void;
  handlergetUserCompetitions(userId: string): Promise<object>;
  handlergetUserSettings(userId: string): void;
  dispatchGetUserCompetitions(userId: string): Promise<object>;
  dispatchFetchTeams(): void;
  dispatchSessionExpire(): void;
  dispatchCheckIfSessionExpired(shouldCallLogout: boolean): Promise<object>;
  dispatchUserLogoutIfLoggedOut(): void;
  dispatchRemoveFlashContexts(path: string[], contexts: string[]): void;
  onRouteChanged(location: string): void;
  dispatchReverifyEmailUser(email: string): Promise<any>;
}

const RedirectToCommunity = () => {
  window.location.replace(COMMUNITY_TOPICS_URL);

  return null;
};

const RedirectToHelpCenter = () => {
  window.location.replace(HELP_CENTER_URL);

  return null;
};

const RedirectToDataExplorer = () => <Redirect to={{ pathname: MAIN_DATA_PATH }} />;

const RedirectToDeactivation = () => <Redirect to={{ pathname: PROFILE_DEACTIVATE_PAGE_PATH }} />;

interface RedirectToSignUpWithReferrerRouteProps {
  userId: string;
}
const RedirectToSignUpWithReferrer = withRouter(({ match }: RouteComponentProps<RedirectToSignUpWithReferrerRouteProps>) => {
  const { data: competition, isLoading, error } = useCompetition(IQC_COMPETITION_ID);

  if (isLoading) {
    return null;
  }

  if (error || !competition) {
    return <Redirect to={{ pathname: SIGN_UP, search: `?referrer=${match.params.userId}` }} />;
  }

  const today = moment();
  const startDate = moment(competition.startDate);
  const signUpEndDate = moment(competition.signUpEndDate);
  const isWithinCompetitionPeriod = today.isSameOrAfter(startDate) && today.isSameOrBefore(signUpEndDate);
  const redirectPath = isWithinCompetitionPeriod ? `${SIGN_UP}/${IQC_COMPETITION_ID}` : SIGN_UP;
  return <Redirect to={{ pathname: redirectPath, search: `?referrer=${match.params.userId}` }} />;
});

const RedirectToOperators = withRouter(({ location }: RouteComponentProps) => (
  <Redirect to={{ pathname: location.pathname.replace('data-and-operators', 'operators'), search: location.search }} />
));

type AppPropsGeneric = RouteComponentProps<AppProps> & AppStateProps & AppStateDispatchers;

// show app messages with delay to avoid hydration errors
interface AppMessagesProps {
  linkHandlers?: { [key: string]: () => void };
}
const AppMessages = ({ linkHandlers }: AppMessagesProps) => {
  const [active, setActive] = useState(false);
  useEffect(() => {
    if (!active) {
      setTimeout(() => setActive(true), 300);
    }
  }, []);

  if (!active || navigator.userAgent === REACT_SNAP_USER_AGENT) {
    return null;
  }

  return (
    <>
      {navigator.userAgent !== REACT_SNAP_USER_AGENT &&
        createPortal(<FlashMessages location="top" linkHandlers={linkHandlers} />, document.getElementById('flashMessages')!)}
    </>
  );
};

class App extends React.Component<AppPropsGeneric, AppState> {
  state = {
    openMobileMenu: false,
  };

  private idTimeout: any;

  UNSAFE_componentWillMount() {
    // Set the referrer tracking cookie
    setUTMCookie();

    const arrayLocation: any = this.props.location.pathname.split('/');

    // Competition Agreement page displays agreement of the competition and not requires authentication
    // Also should not redirect to /sign-in/<competition-id> with competition agreement page
    const isCompetitionAgreementPage = /^\/competition\/[^\/]+\/agreement\/?$/.test(this.props.location.pathname);

    const isCompetitionPage = arrayLocation.includes('competition') && !isCompetitionAgreementPage;

    if (this.props.isLoggedIn && isCompetitionPage) {
      const competitionId = arrayLocation[arrayLocation.length - 1];
      this.props.dispatchSetLogoutCompetition(competitionId);
      this.props
        .dispatchGetCompetition(competitionId)
        .then((res: any) => {
          if (res.type === 'RESPONSE_COMPETITION_FAILURE') {
            this.props.history.push('/');
          }
        })
        .catch((e: any) => logErrorService(e, e));
    }

    this.props
      .authenticationLogin()
      .then(() => {
        if (isCompetitionPage && !this.props.isLoggedIn) {
          const competitionId = arrayLocation[arrayLocation.length - 1];
          this.props.history.push(`/sign-up/${competitionId}`);
        }
      })
      .catch();
    this.props.dispatchGetConfiguration();
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
  }

  handleCheckIfHasCookie() {
    this.props
      .authenticationLogin()
      .then((action: any) => {
        if (action.type === 'AUTHENTICATION_LOGIN') {
          this.props.dispatchGetConfiguration();
        } else {
          this.props.history.push({
            pathname: '/sign-in',
            state: { from: this.props.location },
          });
        }
      })
      .catch();
  }

  handleVisibilityChange = () => {
    const regex =
      /^\/(sign-(in|up)|sign-(in|up)\/([a-zA-Z0-9_.-])*\/?)$|^\/(verify|reverify|forgot-password|reset-password|set-password|events)\/?$/g;
    const checkIfRouteIsValid = this.props.location.pathname.match(regex);
    if (!document.hidden) {
      this.props
        .dispatchCheckIfSessionExpired(!Boolean(checkIfRouteIsValid))
        .then((action: any) => {
          if (action && action.type === 'AUTHENTICATION_LOGIN' && this.props.userId !== action.payload.user.id) {
            this.handleCheckIfHasCookie();
          }
        })
        .catch();
    }
  };

  addFlashMessageUnverifiedEmail() {
    const { unverifiedEmail, unverifiedEmailFlashMessages, isLoggedIn } = this.props;
    if (!isLoggedIn || !unverifiedEmail) {
      return;
    }
    // Deduplicate: only dispatch if no existing flash message with this key
    const alreadyShown =
      unverifiedEmailFlashMessages &&
      unverifiedEmailFlashMessages.some((msg: any) => msg && msg.get && msg.get('msg') === 'change.email.resend.verify');
    if (alreadyShown) {
      return;
    }
    this.props.dispatchAddFlashMessages(
      [
        {
          msg: 'change.email.resend.verify',
          defaultMessage: localeData.en['change.email.resend.verify'],
          intlValues: { unverified: unverifiedEmail },
        },
      ],
      {
        notBlink: true,
        type: 'info',
        // Reference the resend handler by name; the actual function is wired
        // in render() via the `linkHandlers` prop on <FlashMessages />.
        // (Function references can't be safely round-tripped through redux/Immutable.)
        props: { linkHandler: 'resendVerifyEmail' },
        inputType: 'button',
        links: [
          {
            urls: [''],
            keys: ['change.email.resend.verify.button'],
            defaultMsgkeys: [localeData.en['change.email.resend.verify.button']],
          },
        ],
      }
    );
  }

  handlerResendVerifyEmail = () => {
    const { unverifiedEmail } = this.props;
    if (!unverifiedEmail) {
      return;
    }
    this.props
      .dispatchReverifyEmailUser(unverifiedEmail)
      .then((action: any) => {
        if (action && action.type === 'REVERIFY_EMAIL_USER_SUCCESS') {
          this.props.history.push('/profile/verify-email');
        }
      })
      .catch();
  };

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (this.props.userId !== nextProps.userId && nextProps.userId) {
      this.props.handlergetUserSettings(nextProps.userId);
      this.props.dispatchFetchSummary();
      this.props
        .handlergetUserCompetitions(nextProps.userId)
        .then(() => {
          this.props.dispatchFetchTeams();
        })
        .catch();
      this.props.dispatchGetOptions();
    }
    if (
      this.props.agreedWithGuidelines === true &&
      this.props.agreedWithGuidelines !== nextProps.agreedWithGuidelines &&
      nextProps.userId
    ) {
      this.props
        .dispatchGetUserCompetitions(nextProps.userId)
        .then(() => {
          this.props.dispatchFetchTeams();
        })
        .catch();
    }
    if (this.props.userTimeout === null && nextProps.userTimeout !== null) {
      clearInterval(this.idTimeout);
      this.idTimeout = setInterval(() => this.checkIfIsTime(nextProps.userTimeout), 1000);
    }
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({ openMobileMenu: false });
      if (
        this.props.location.pathname === '/profile/account/basic-details' &&
        nextProps.location.pathname !== '/profile/account/basic-details'
      ) {
        this.props.dispatchRemoveFlashContexts(['top'], ['edit-passord']);
      }
    }
  }

  handleMobileMenu = () => {
    this.setState(prevState => ({ openMobileMenu: !prevState.openMobileMenu }));
  };

  handlerErrorListener = () => {
    let appIsHandlingError = false;
    window.onerror = (message, _, ___, ____, error) => {
      if (!appIsHandlingError) {
        appIsHandlingError = true;
        const mailRef = `"mailto:${APP_EMAIL}?subject=An Application Error Has Occurred For ${this.props.userId || 'Not Signed In User'}"`;
        const errorMessage =
          'WorldQuant BRAIN is experiencing some difficulties. ' +
          `Please contact <a className="error-boundary__element-link" href=${mailRef}>support</a > if this problem persists.`;
        logErrorService(message, error);

        // Since this error is caused by microsoft/vscode unless updating the library.
        // Adding this check to ignore showing error to UI but still sending to Sentry
        // https://jira.worldquant.com/browse/BRAINTECH-1626?focusedCommentId=1271748#comment-1271748
        // https://jira.worldquant.com/browse/BRAINTECH-1626?focusedCommentId=1293262#comment-1293262
        if (typeof message === 'string' && message.indexOf('getModifierState is not a function') !== -1) {
          return;
        }

        this.props.dispatchErrorMessage(errorMessage);
      }
    };
  };

  showVBCMessage = (message: string) => {
    const closedVBCMessage = localStorageService?.getItem(message);

    return !closedVBCMessage;
  };

  handleVBCMessage = () => {
    const message = this.props.isConsultant ? 'message.consultant.vbc' : 'message.user.vbc';
    const showVBCMessage = this.showVBCMessage(message);
    const endDate = moment(this.props.isConsultant ? '09/22/2019' : '09/29/2019', 'MM/DD/YYYY').tz('America/New_York');
    const currentDate = moment().tz('America/New_York');
    if (showVBCMessage && currentDate.isBefore(endDate)) {
      this.props.dispatchAddFlashMessage(message);
    }
  };

  componentDidUpdate(prevProps: any) {
    const isFetching = this.props.fetchingAuthCheck !== null && !this.props.isFetchingLogout && !this.props.fetchUserCompetitions;
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.props.onRouteChanged(this.props.location.pathname);
    }
    if (isFetching && this.props.isLoggedIn) {
      this.handleVBCMessage();
    }
    // Show the unverified-email flash message whenever the user is logged in
    // and has an unverifiedEmail. Triggered on:
    //   - login transition (isLoggedIn went from false → true)
    //   - unverifiedEmail appearing for the first time
    //   - route change while unverifiedEmail is still set
    // Reusing the existing FlashMessages mechanism (rather than a dedicated
    // banner component) keeps the layout consistent — when the user dismisses
    // the message, the layout reflows naturally because the flash-messages
    // container collapses, which is what the simulate page expects.
    const justLoggedIn = !prevProps.isLoggedIn && this.props.isLoggedIn;
    const unverifiedEmailAppeared = !prevProps.unverifiedEmail && this.props.unverifiedEmail;
    const routeChangedWithUnverified = this.props.location.pathname !== prevProps.location.pathname && this.props.unverifiedEmail;
    if (this.props.isLoggedIn && this.props.unverifiedEmail && (justLoggedIn || unverifiedEmailAppeared || routeChangedWithUnverified)) {
      this.addFlashMessageUnverifiedEmail();
    }
  }

  componentDidMount() {
    window.addEventListener('error', this.handlerErrorListener);
    const item = localStorageService?.getItem('websim_version');
    if (!(item && item === APP_VERSION)) {
      clearStoredReduxState();
      localStorageService?.setItem('websim_version', APP_VERSION);
    }
  }

  componentWillUnmount() {}

  checkIfIsTime(timeout: string) {
    if (moment().isSameOrAfter(moment(timeout))) {
      this.props.dispatchSessionExpire();
      clearInterval(this.idTimeout);
    }
  }

  render() {
    const { isLoggedIn, isFetchingLogout, fetchingAuthCheck, recert, fetchUserCompetitions } = this.props;
    const notFetching = !isFetchingLogout && !fetchUserCompetitions;
    const pathName = this.props.location.pathname.substr(1).replace(/\//g, '-');

    return (
      <ErrorBoundary showUI={true}>
        <div className={`app-${pathName} ${navigator.userAgent === REACT_SNAP_USER_AGENT ? 'react-snap' : ''}`}>
          <ErrorBoundary showUI={true}>
            <Header openMobileMenu={this.state.openMobileMenu} handleMobileMenu={this.handleMobileMenu} />
          </ErrorBoundary>
          <div id="flashMessages"></div>
          <AppInitAltcha />
          <Route component={ScrollToTop} />
          <Switch>
            {/*Uncomment to show IQC page again: */}
            <Route path={IQC_LANDING_ROUTE} exact={true} component={IQCLanding} />
            <Route path={CONSULTANT_PROGRAM_LANDING_PATH} exact={true} component={ConsultantLanding} />
            <Route
              component={() => (
                <Helmet titleTemplate="%s | WorldQuant BRAIN" defaultTitle="WorldQuant BRAIN">
                  <meta property="og:title" content="Join WorldQuant BRAIN" />
                  <meta
                    property="og:description"
                    content="The platform that helps you Learn, Earn and Grow in the field of Quantitative Finance. WorldQuant BRAIN introduces its
             users to the intriguing world of quantitative finance in an interactive way through its simulation platform,
              and provides global talent the opportunity to become research consultants in select approved countries and participate in
               WorldQuant’s greater research efforts. Our platform includes data sets and tools, performance dashboards and value-add
                measures. Join us on our journey."
                  />
                </Helmet>
              )}
            />
          </Switch>
          {fetchingAuthCheck !== null && notFetching && <OnboardingPopupContainer />}
          {fetchingAuthCheck !== null && notFetching && isLoggedIn && <GoldTierModal />}
          {fetchingAuthCheck !== null && notFetching && isLoggedIn && <StreakFreezeUnlockModal />}
          {fetchingAuthCheck !== null && notFetching ? (
            <React.Suspense fallback={<Loader active={true} inline="centered" size="massive" />}>
              <Switch>
                <PrivateRoute path="/" exact={true} needsRecertification={recert} component={Dashboard} isAuthenticated={isLoggedIn} />
                <PrivateRoute path="/simulate" isAuthenticated={isLoggedIn} component={Simulate} needsRecertification={recert} />
                <PrivateRoute path={ALPHAS_SUPER_SELECTION} isAuthenticated={isLoggedIn} needsRecertification={recert} component={Alphas} />
                <PrivateRoute path="/alphas/:id/alphas" isAuthenticated={isLoggedIn} needsRecertification={recert} component={Alphas} />
                <PrivateRoute path="/alphas/:id" isAuthenticated={isLoggedIn} needsRecertification={recert} component={Alphas} />
                <PrivateRoute path={ALPHA_DETAIL_PATH} needsRecertification={recert} isAuthenticated={isLoggedIn} component={Alpha} />
                <RecertificateRoute path="/profile" needsRecertification={recert} component={Profile} />
                <RecertificateRoute path="/events/:id?" component={Events} needsRecertification={recert} />
                <PrivateRoute path="/data" needsRecertification={recert} isAuthenticated={isLoggedIn} component={DataRoutes} />
                <PrivateRoute
                  path={`/${LEARN_OLD_DATA_AND_OPERATORS_PAGE_PATH}/datasets`}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={RedirectToDataExplorer}
                />
                <PrivateRoute
                  path={`${LEARN_OLD_DATA_AND_OPERATORS_PAGE_PATH}/consultant-datasets`}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={RedirectToDataExplorer}
                />
                <PrivateRoute
                  path={`${LEARN_OPERATORS_PAGE_PATH}/datasets`}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={RedirectToDataExplorer}
                />
                <PrivateRoute
                  path={`${LEARN_OPERATORS_PAGE_PATH}/consultant-datasets`}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={RedirectToDataExplorer}
                />
                <PrivateRoute
                  path={`${LEARN_OLD_DATA_AND_OPERATORS_PAGE_PATH}/`}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={RedirectToOperators}
                />
                <PrivateRoute path="/learn" needsRecertification={recert} isAuthenticated={isLoggedIn} component={Learn} />
                <RecertificateRoute path="/sign-up/:id?" needsRecertification={recert} component={AccountCreate} />
                <RecertificateRoute path="/sign-in/:id?" needsRecertification={recert} component={Authentication} />
                <PrivateRoute path="/messages/:type" needsRecertification={recert} isAuthenticated={isLoggedIn} component={Messages} />
                <PrivateRoute
                  path="/messages/:type/:filter"
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={Messages}
                />
                <PrivateRoute path="/contact-us" component={RedirectToHelpCenter} isAuthenticated={isLoggedIn} />
                <PrivateRoute path="/community" component={RedirectToCommunity} isAuthenticated={isLoggedIn} />
                <PrivateRoute path="/deactivate" component={RedirectToDeactivation} isAuthenticated={isLoggedIn} />
                <Route path="/referral" exact={true} component={ReferralPage} />
                <Route path="/referral/:userId" component={RedirectToSignUpWithReferrer} />
                <PrivateRoute path="/genius/:page?" needsRecertification={recert} isAuthenticated={isLoggedIn} component={GeniusPage} />
                <PrivateRoute
                  path="/competitions"
                  exact={true}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={AllCompetitions}
                />
                <Redirect from="/competition/consultant/spc/submissions" to="/competition/spc/submissions" />
                <Redirect from="/competition/consultant/spc" to="/competition/spc" />
                <Redirect from="/competition/consultant/power-pool" to="/competition/power-pool" />
                <Redirect from="/competition/consultant/referrals" to="/competition/referrals" />
                <PrivateRoute
                  path="/competition/:id(spc)/:filterName(submissions)"
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={Competitions}
                />
                <PrivateRoute
                  path="/competition/:id/submissions"
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={CompetitionSubmissions}
                />
                <Route path="/competition/:competitionId/agreement" component={PublicAgreement} />
                <PrivateRoute
                  path={COMPETITION_DETAILS_PATH}
                  needsRecertification={recert}
                  isAuthenticated={isLoggedIn}
                  component={Competitions}
                />
                <RecertificateRoute path="/verify" needsRecertification={recert} component={AccountVerified} />
                <RecertificateRoute path="/reverify" needsRecertification={recert} component={Reverify} />
                <RecertificateRoute path="/forgot-password" needsRecertification={recert} component={ForgotPassword} />
                <RecertificateRoute path="/reset-password" needsRecertification={recert} component={ResetPassword} />
                <RecertificateRoute path="/set-password" needsRecertification={recert} component={SetPassword} />
                <Route path="/agreements/:agreementId" component={PublicAgreement} />
                <Route
                  exact={true}
                  path={recert ? '/recertification/:slug(basic-details|location|education|employment|recruitment|recertify-account)' : '/'}
                  component={AccountRecertify}
                />
                <PrivateRoute path="/team" needsRecertification={recert} isAuthenticated={isLoggedIn} component={Team} />
                <Route path={ALPHATHON_LANDING_PATH} exact={true} component={AlphathonLanding} />
                {/* need to duplicate ssr routes not to catch not found */}
                {/*uncomment to enable IQC*/}
                <Route path={IQC_LANDING_ROUTE} exact={true} component={() => null} />
                <Route path={CONSULTANT_PROGRAM_LANDING_PATH} exact={true} component={() => null} />
                <Route component={NotFound} />
              </Switch>
            </React.Suspense>
          ) : (
            <ErrorBoundary showUI={true} isNotFullScreen={true}>
              <Loader modifiers={['app']} active={true} inline="centered" size="massive" />
            </ErrorBoundary>
          )}
        </div>
        {!isLoggedIn && !recert && fetchingAuthCheck !== null && <Footer />}
        <GoogleAnalytics />
        <GoogleTagManager />
        <GoogleAds />
        <AppMessages linkHandlers={{ resendVerifyEmail: this.handlerResendVerifyEmail }} />
        <ScrollTracker />
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state: StateType): AppStateProps => ({
  // @ts-ignore
  userId: getUserIdSelector(state),
  isConsultant: hasConsultantPermission(state),
  // @ts-ignore
  isLoggedIn: getIsLoggedInSelector(state),
  // @ts-ignore
  agreedWithGuidelines: competitionFetchAgreeGuidelinesSelector(state),
  // @ts-ignore
  fetchingAuth: getUserIsFetchingSelector(state),
  // @ts-ignore
  userPermissions: getUserPermissionsSelector(state),
  // @ts-ignore
  userTimeout: getUserTimeToLogoutSelector(state),
  // @ts-ignore
  hasLoggedInBefore: getUserHasLoggedInBeforeSelector(state),
  // @ts-ignore
  fetchingAuthCheck: getUserFetchingAuthSelector(state),
  // @ts-ignore
  isFetchingLogout: getUserIsFetchingLogoutSelector(state),
  // @ts-ignore
  recert: getUserNeedsRecertificationSelector(state),
  // @ts-ignore
  redirectUrl: getRedirectUrl(state),
  // @ts-ignore
  fetchUserCompetitions: competitionFetchUserCompetitionsSelector(state),
  // @ts-ignore
  unverifiedEmail: accountUnverifiedEmailSelector(state),
  // @ts-ignore
  unverifiedEmailFlashMessages: flashMessagesTopGenericMessageSelector(state),
});

function mapDispatchToProps(dispatch: Dispatch<any>): AppStateDispatchers {
  const flashMessageOptions: any = { type: 'info', notBlink: true };

  return {
    dispatchGetOptions: () => {
      dispatch(fetchSimulationOptions());
    },
    dispatchErrorMessage: (message: string) => {
      dispatch(addFlashMessages([message]));
    },
    dispatchAddFlashMessage: (message: string) => {
      dispatch(
        addFlashMessages(
          [
            {
              msg: message,
              defaultMessage: localeData.en[message],
            },
          ],
          flashMessageOptions
        )
      );
    },
    dispatchAddFlashMessages: (messages: Object[], option: any) => dispatch(addFlashMessages(messages, option)),
    dispatchReverifyEmailUser: async (email: string) => dispatch(reverifyEmailUser(email)),
    authenticationLogin: async () => dispatch(checkIfAuth()),
    handlergetUserCompetitions: async (userId: string) => dispatch(getUserCompetitions(userId)),
    handlergetUserSettings: async (userId: string) => {
      const userSettingsPromise = dispatch(getUserSettings(userId));
      const alphasOptionsPromise = dispatch(fetchAlphasOptions(userId));

      return Promise.all([userSettingsPromise, alphasOptionsPromise]);
    },
    dispatchFetchSummary: () => {
      dispatch(getSummary());
    },
    dispatchGetUserCompetitions: async (userId: string) => dispatch(getUserCompetitions(userId)),
    dispatchSessionExpire: () => {
      dispatch(sessionExpire());
    },
    dispatchGetConfiguration: () => {
      dispatch(getConfiguration());
    },
    dispatchUserLogoutIfLoggedOut: () => {
      dispatch(userLogoutIfLoggedOut());
    },
    dispatchFetchTeams: async () => dispatch(fetchAllTeams()),
    dispatchGetCompetition: async (competitionId: string) => dispatch(getCurrentCompetition(competitionId)),
    dispatchSetLogoutCompetition: (competition: string) => dispatch(setLogoutCompetition(competition)),
    dispatchRemoveFlashContexts: (path: string[], contexts: string[]) => dispatch(removeFlashContexts(path, contexts)),
    dispatchCheckIfSessionExpired: async (shouldCallLogout: boolean) => dispatch(checkIfSessionExpired(shouldCallLogout)),
    onRouteChanged: (location: string) => {
      dispatch(removeAllFlashMessages());

      try {
        analytics.trackPage();
      } catch (err) {
        logErrorService(err, err);
      }
    },
  };
}

export default withRouter(
  connect<AppStateProps, DispatchConnect<AppStateDispatchers>, any, StateType>(mapStateToProps, mapDispatchToProps)(App)
);
